/*************************************************/
/* COOKIES                                       */
/*************************************************/

export function cookies() {
    const placeholderSelector = '.cookie-placeholder';

    const init = function () {

        SetPlaceholderState();

        $(placeholderSelector).on('click', function (event) {
            event.stopPropagation()
            var category = $(this).attr('data-category');
            RenewConsent(category);
        });

    };

    init();


    //Implement this for the specific cookie solution
    function RenewConsent(category) {
        Cookiebot.renew();
    }

    //Implement this for the specific cookie solution
    function SetPlaceholderState() {
        window.addEventListener('CookiebotOnConsentReady', function (event) {

            var marketingPlaceholders = $(placeholderSelector + '[data-category="marketing"]');
            if (marketingPlaceholders) {
                var displayState = Cookiebot.consent.marketing ? 'none' : 'flex';
                marketingPlaceholders.css('display', displayState);
            }

            var statisticPlaceholders = $(placeholderSelector + '[data-category="statistic"]');
            if (statisticPlaceholders) {
                var displayState = Cookiebot.consent.statistics ? 'none' : 'flex';
                statisticPlaceholders.css('display', displayState);
            }

            var preferencesPlaceholders = $(placeholderSelector + '[data-category="preferences"]');
            if (preferencesPlaceholders) {
                var displayState = Cookiebot.consent.preferences ? 'none' : 'flex';
                preferencesPlaceholders.css('display', displayState);
            }

        }, false);
    }
}

